import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '../../hooks/useScrollReveal';
import { SectionHeader } from '../ui/SectionHeader';
import { FOUNDERS } from '../../lib/constants';
import styles from './TeamSection.module.css';

export const TeamSection = () => {
  const { t } = useTranslation();
  const [ref, visible] = useScrollReveal(0.15);

  const getInitials = (name: string) =>
    name
      .split(' ')
      .map((n) => n[0])
      .join('');

  return (
    <section id="team" ref={ref as React.RefObject<HTMLElement>} className={styles.section}>
      <div className="container">
        <SectionHeader
          label={t('team.label')}
          title={t('team.title')}
          subtitle={t('team.subtitle')}
        />

        <div className={styles.grid}>
          {FOUNDERS.map((founder, idx) => (
            <div
              key={founder.name}
              className={`${styles.card} ${visible ? styles.cardVisible : ''}`}
              style={{ transitionDelay: `${idx * 150}ms` }}
            >
              <div className={styles.avatar}>
                {founder.photo ? (
                  <img src={founder.photo} alt={founder.name} className={styles.avatarImg} />
                ) : (
                  <span className={styles.initials}>{getInitials(founder.name)}</span>
                )}
              </div>
              <h3 className={styles.name}>{founder.name}</h3>
              <p className={styles.role}>{founder.role}</p>
              <a href={founder.linkedin} className={styles.linkedin} target="_blank" rel="noopener noreferrer">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                </svg>
                LinkedIn
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
